/**
 * @generated SignedSource<<9d2df0f1cd34eac0c9477fcb303a25cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OSType = "FreeBSD" | "Linux" | "Solaris" | "Unix" | "Unknown" | "Windows" | "macOS";
export type AssignAgentsDialogAssignablePoolItemsQuery$variables = {
  agentPoolId: string;
};
export type AssignAgentsDialogAssignablePoolItemsQuery$data = {
  readonly agentPool: {
    readonly assignableAgents?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agentPool: {
            readonly id: string;
            readonly name: string | null;
            readonly rawId: string;
          } | null;
          readonly authorized: boolean | null;
          readonly connected: boolean | null;
          readonly enabled: boolean | null;
          readonly environment: {
            readonly os: {
              readonly type: OSType;
            } | null;
          } | null;
          readonly id: string;
          readonly name: string | null;
          readonly rawId: string;
          readonly " $fragmentSpreads": FragmentRefs<"AssignAgentsDialogAgentFragment">;
        };
      }>;
    } | null;
    readonly assignableCloudImages?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agentPool: {
            readonly id: string;
            readonly name: string | null;
            readonly rawId: string;
          } | null;
          readonly agentTypeRawId: string | null;
          readonly id: string;
          readonly instances: {
            readonly count: number;
          } | null;
          readonly name: string | null;
          readonly rawId: string;
        };
      }>;
    } | null;
    readonly id: string;
    readonly maxAgentsNumber: number | null;
    readonly name: string | null;
    readonly rawId: string;
  } | null;
};
export type AssignAgentsDialogAssignablePoolItemsQuery = {
  response: AssignAgentsDialogAssignablePoolItemsQuery$data;
  variables: AssignAgentsDialogAssignablePoolItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentPoolId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentPoolId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxAgentsNumber",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTypeRawId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "agentPool",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "CloudImageInstancesConnection",
  "kind": "LinkedField",
  "name": "instances",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorized",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AgentEnvironment",
  "kind": "LinkedField",
  "name": "environment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OS",
      "kind": "LinkedField",
      "name": "os",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "agentPool",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignAgentsDialogAssignablePoolItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "agentPool",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentPoolCloudImagesConnection",
                "kind": "LinkedField",
                "name": "assignableCloudImages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentPoolCloudImageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CloudImage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentPoolAgentsConnection",
                "kind": "LinkedField",
                "name": "assignableAgents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentPoolAgentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AssignAgentsDialogAgentFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentPool",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignAgentsDialogAssignablePoolItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "agentPool",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentPoolCloudImagesConnection",
                "kind": "LinkedField",
                "name": "assignableCloudImages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentPoolCloudImageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CloudImage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v14/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentPoolAgentsConnection",
                "kind": "LinkedField",
                "name": "assignableAgents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentPoolAgentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v14/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentPool",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "802f8112d9ea8b7858b70c9920312f06",
    "id": null,
    "metadata": {},
    "name": "AssignAgentsDialogAssignablePoolItemsQuery",
    "operationKind": "query",
    "text": "query AssignAgentsDialogAssignablePoolItemsQuery(\n  $agentPoolId: ID!\n) {\n  agentPool(id: $agentPoolId) {\n    __typename\n    id\n    rawId\n    name\n    maxAgentsNumber\n    ... on AgentPool {\n      assignableCloudImages {\n        edges {\n          node {\n            id\n            rawId\n            name\n            agentTypeRawId\n            agentPool {\n              __typename\n              id\n              rawId\n              name\n            }\n            instances {\n              count\n            }\n          }\n        }\n      }\n      assignableAgents {\n        edges {\n          node {\n            id\n            rawId\n            name\n            authorized\n            enabled\n            connected\n            agentPool {\n              __typename\n              id\n              rawId\n              name\n            }\n            environment {\n              os {\n                type\n              }\n            }\n            ...AssignAgentsDialogAgentFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AssignAgentsDialogAgentFragment on Agent {\n  id\n  name\n  connected\n  enabled\n  environment {\n    os {\n      type\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "052e0a20b57fdd5141dcb162c2509888";

export default node;
